<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="border-none py-0 mb-0 px-1">
      <b-card-body class="py-0">
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="Transaction Date" label-size="sm">
              <b-input-group>
                <daterangepicker size="sm" ref="datetransaction" v-model="datetransaction" :opens="'right'"
                  :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                  :single-date-picker="'range'">
                </daterangepicker>
                <b-input-group-append>
                  <b-button size="sm" variant="outline-secondary" @click="
                    datetransaction = {
                      startDate: null,
                      endDate: null,
                    }
                    ">
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Email To" label-for="email" label-cols="12">
              <b-input-group>
                <b-form-input type="text" v-model="emailto" placeholder="Email" size="sm"></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" variant="outline-secondary" @click="emailto = ''">
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card class="border-none py-0 mb-0 px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="mr-1"></i>
        NL Post
      </b-card-header>

      <b-card-body class="py-0">
        <div>
          <b-overlay :show="options.overlay_show" opacity=".9" v-click-outside="outside">
            <!-- :items="this[options.bvtid + '_items']" -->
            <div class="availtable datatable nested">
              <b-table :dark="$store.state.darkMode" :ref="options.bvtid" sticky-header="350px" striped hover small
                caption-bottom show-empty selectable select-mode="multi" foot-clone no-footer-sorting
                :busy="this[options.bvtid + '_busy']" :items="items" :fields="options.fields"
                :filter="this[options.bvtid + '_find']" @row-selected="rowSelected($event, options.bvtid)">
                <template #head(selected)>
                  <i id="selectall" class="ml-1" :class="headselected(options.bvtid)" aria-hidden="true"
                    title="Click to select/unselect all"></i>
                  <!-- @click="headselectedClick(options.bvtid)" -->
                  <b-tooltip target="selectall" triggers="hover" placement="right">Click to select/unselect
                    all</b-tooltip>
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner type="grow" variant="primary" class="align-middle mr-2"></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="rowIcon(slot.item)"></i>
                </template>

                <template v-slot:cell()="row">
                  <div v-if="
                    options.badges &&
                    options.badges.find((obj) => obj.key == row.field.key)
                  ">
                    <span v-html="rowBadgeCell(
                      row.item,
                      options.badges.find(
                        (obj) => obj.key == row.field.key
                      ),
                      options
                    )
                      "></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button variant="link" size="sm" title="Actions" :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')">
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover container="actions-container" triggers="click blur" placement="leftbottom"
                      :target="'popover-target-' + row.item.id">
                      <div>
                        <b-nav vertical>
                          <b-nav-item :title="action.label" v-for="action in rowActionCell(row.item, options)"
                            :key="action.key" @click.stop="
                              rowClick(action.key, row, options.bvtid)
                              ">
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i :class="rowActionIcon(action, row.item)"></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button variant="link" size="sm" v-for="action in rowActionCell(row.item, options)"
                      :key="action.key" @click.stop="rowClick(action.key, row, options.bvtid)" :title="action.label">
                      <i :class="rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component :is="options.component.name" :selection="btable_selected" :config="cconfig"
                      @discard="toolClick('discard')" @refresh="toolClick('refresh')"></component>
                  </b-card>
                </template>
                <template v-slot:foot()="row">
                  <span v-if="row.field.totalled" class="strong text-primary">
                    {{ row.field.total }}</span>
                  <span v-else></span>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button v-for="(button, index) in options.overlay.buttons" :key="index"
                      :style="button.style ? button.style : 'width: 80px'" :class="button.class
                        ? button.class
                        : button.dispatch
                          ? null
                          : 'ml-2'
                        " :variant="button.variant
                          ? button.variant
                          : button.dispatch
                            ? 'outline-primary'
                            : 'outline-secondary'
                          " :size="button.size ? button.size : 'sm'" :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? dispatcher(button.dispatch)
                          : (options.overlay_show = false)
                        ">{{ button.label }}</b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
          <b-row class="excelsheetbuttons px-1 mb-3 mt-n2">
            <b-col>
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin"></i>
                <span class="ml-1">Updating ...</span>
              </div>
              <span class="small" v-if="!busy">Found {{ this[options.bvtid + "_items"].length }} rows</span>
            </b-col>

            <b-col class="text-right">
              <b-link id="flights-excel" class="mt-1 mr-1 excel" @click="
                table_excel({ items: excelitems, fields: options.fields })
                " title="Send to excel">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
              </b-link>
              <b-tooltip target="flights-excel" triggers="hover">Grid to excel</b-tooltip>
              <b-link id="flights-refresh" class="mt-1 excel" @click="load" title="Refresh">
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </b-link>
              <b-tooltip target="flights-refresh" triggers="hover">Refresh</b-tooltip>
            </b-col>
          </b-row>
        </div>
      </b-card-body>

      <b-card-footer class="mt-2 px-0">
        <b-row align-h="end">
          <b-col cols="auto" class="text-left">

            <b-button squared size="sm" variant="primary" @click="saveit"
              :disabled="this[this.options.bvtid + '_items'] > 0">
              <i class="fa fa-check"></i>
              Post It
            </b-button>

          </b-col>
          <b-col class="text-left ml-2 mt-1">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>

          <b-col class="text-right" cols="2">
            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>

          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "TicketsRoutefix",
  data() {
    return {
      busy: false,
      datetransaction: {
        startDate: this.$moment().startOf("month").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      emailto: "accounts@travelplaces.co.uk",
      line: {},
      item: {},
      items: [],
      // items: [
      //   {
      //     label: "LCC",
      //     supp_type: "A",
      //     sales_account: "4510",
      //     cost_account: "6510",
      //   },
      //   {
      //     label: "Bus Mtgs",
      //     supp_type: "B",
      //     sales_account: "4650",
      //     cost_account: "6650",
      //   },
      //   {
      //     label: "Car Hire",
      //     supp_type: "C",
      //     sales_account: "4540",
      //     cost_account: "6540",
      //   },
      //   {
      //     label: "Delivery",
      //     supp_type: "D",
      //     sales_account: "4540",
      //     cost_account: "6540",
      //   },
      //   {
      //     label: "Cust Expenses",
      //     supp_type: "E",
      //     sales_account: "4680",
      //     cost_account: "6680",
      //   },
      //   {
      //     label: "Ferry",
      //     supp_type: "F",
      //     sales_account: "4550",
      //     cost_account: "6550",
      //   },
      //   {
      //     label: "Ground Handling",
      //     supp_type: "G",
      //     sales_account: "4690",
      //     cost_account: "6690",
      //   },
      //   {
      //     label: "Hotels",
      //     supp_type: "H",
      //     sales_account: "4560",
      //     cost_account: "6560",
      //   },
      //   {
      //     label: "Insurance",
      //     supp_type: "I",
      //     sales_account: "4570",
      //     cost_account: "6570",
      //   },
      //   {
      //     label: "Event Tkts",
      //     supp_type: "J",
      //     sales_account: "4580",
      //     cost_account: "6580",
      //   },
      //   {
      //     label: "Curr Exch",
      //     supp_type: "K",
      //     sales_account: "4590",
      //     cost_account: "6590",
      //   },
      //   {
      //     label: "Le Shuttle",
      //     supp_type: "L",
      //     sales_account: "4600",
      //     cost_account: "6600",
      //   },
      //   {
      //     label: "Misc",
      //     supp_type: "M",
      //     sales_account: "4610",
      //     cost_account: "6610",
      //   },
      //   {
      //     label: "Packages",
      //     supp_type: "P",
      //     sales_account: "4620",
      //     cost_account: "6620",
      //   },
      //   {
      //     label: "Transaction Fees",
      //     supp_type: "Q",
      //     sales_account: "4620",
      //     cost_account: "6620",
      //   },
      //   {
      //     label: "Rail",
      //     supp_type: "R",
      //     sales_account: "4630",
      //     cost_account: "6630",
      //   },
      //   {
      //     label: "Tour Operators",
      //     supp_type: "T",
      //     sales_account: "4640",
      //     cost_account: "6640",
      //   },
      //   {
      //     label: "Pax Visas",
      //     supp_type: "V",
      //     sales_account: "4710",
      //     cost_account: "6710",
      //   },
      //   {
      //     label: "BSP",
      //     supp_type: "X",
      //     sales_account: "4530",
      //     cost_account: "6530",
      //   },
      //   {
      //     label: "Charters Y",
      //     supp_type: "Y",
      //     sales_account: "4515",
      //     cost_account: "6515",
      //   },
      //   {
      //     label: "Charters S",
      //     supp_type: "S",
      //     sales_account: "4700",
      //     cost_account: "6700",
      //   },
      // ],

      options: {
        title: "NL Post",
        icon: "fa fa-balance-scale text-primary",
        debounce: 500,
        bvtid: "ctable",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "suptype",
            label: "Supplier Type",
            sortable: true,
            class: "text-center",
          },
          {
            key: "sales_account",
            label: "Sales NL A/C",
            sortable: true,
            class: "text-center",
          },
          {
            key: "costs_account",
            label: "Costs NL A/C",
            sortable: true,
            class: "text-center",
          },

          {
            key: "label",
            label: "Comment",
            sortable: true,
            class: "text-left",
          },
        ],
        badges: [],
        actions: [],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  async mounted() {
    //this.load();
    this.emailto = this.user.email;

    this.loadData();

  },

  watch: {
    async datetransaction() {
      await this.load();
    },
  },
  computed: {
    readonly() {
      return false;
    },
  },
  methods: {
    // async loadDDL() {
    //   this.busy = true;
    //   this.busy = false;
    // },

    async loadData() {
      this.items = [];

      this.busy = true;

      let variables = {};
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query nlpost_suptypes {
              nlpost_suptypes {
                suptype
                label
                sales_account
                costs_account
              }
            }
          `,
          variables,
        });
        console.log(response.data.nlpost_suptypes);

        this.items = response.data.nlpost_suptypes;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
      // await this.$emit("refreshed");
    },

    // async load() {
    //   this.busy = true;

    //   this.tableItems(this.items, this.options.bvtid, this.options.fields);

    //   this.$refs[this.options.bvtid].selectAllRows();

    //   this.busy = false;
    // },
    async _toolClick(a) {
      console.log("local toolClick: ", a);
      return;
    },
    _toolDisabled(a) {
      console.log("local toolDisabled: ", a);
      return;
    },

    async saveit() {
      this.busy = true;

      let variables = {
        dateformat: "DD/MM/YY",
        emailto: this.emailto,
        nldates: [this.$moment(this.datetransaction.startDate).format("YYYY-MM-DD"), this.$moment(this.datetransaction.endDate).format("YYYY-MM-DD")]
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation nlpost_PG($emailto: String, $nldates: [String], $nlcodes: [String]) {
              nlpost_PG(emailto: $emailto, nldates: $nldates, nlcodes: $nlcodes) 
            }
          `,
          variables,
        });
        console.log("response is", response.data.nlpost_PG);

        if (response.data.nlpost_PG.length > 0) {
          // this.tableItems(
          //   response.data.NLTransactions,
          //   this.options.bvtid,
          //   this.options.fields
          // );
        }
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
      // await this.load();
      this.busy = false;
    },
  },
};
</script>

<style></style>